import styled from 'styled-components'

export const Art = styled.img`
  border-radius: 8px;
  width: 100%;
  height: 100%;
  margin-bottom: -6px;
  position: relative;
  z-index: 2;
`
